export default __webpack_public_path__ + "static/media/hero.d1d5d8fb.png";